import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import DynamicPage from '../pages/DynamicPage'
import StaticPage from '../pages/StaticPage'
import { useAuth } from '../modules/auth'


const DynamicRoutes: React.FC = () => {

    const { currentUser } = useAuth()
    const isDevPermission = currentUser?.permissions?.some(permission => permission.article === "support") ?? false

    return <Routes>
        <Route element={<MasterLayout />}>
            {/* Redirect to users after success login/registartion */}
            <Route path='auth/*' element={<Navigate to='/dashboard' />} /> {/* нужно будет передавать начальную страницу */}
            <Route path='dev/*' element={isDevPermission ? <StaticPage /> : <Navigate to='/dashboard' />} />
            <Route path='*' element={<DynamicPage />} />

        </Route>
    </Routes>
}

export default DynamicRoutes